import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';
import * as selectors from './selectors';

export const getFailureTests = () => async (dispatch, getState) => {
  const testsParams = selectors.queryParamSelector(getState());
  return dispatch(actions.getFailureTests(testsParams)).catch((error) => {
    dispatch(notificationActions.notifyDanger(
      error.message, 'We\'ve experienced an issue while fetching tests.', true,
    ));
  });
};

export const fetchRootCausesForTest = ({ index, item }) => async (dispatch, getState) => {
  const params = selectors.queryParamSelector(getState(), {
    test_hash: item.get('id'),
  });
  return dispatch(
    actions.getRootCauses({
      index,
      params,
    }),
  );
};
